import $t from '../../../../i18n'
import Page from '../../../common/Page'
import PageCard from '../../../common/PageCard'
import config from '../../../../config.json'
import Actions from '../../../../actions'
import { Button } from 'antd'
import { useDispatch } from 'react-redux'
import { routes } from '../../../../consts'

import './SignupErrorPage.css'

const SignupErrorPage = () => {
  const dispatch = useDispatch()
  return (
    <PageCard
      className="login-page-card signup-error-page-card"
      enableBack={true}
    >
      <Page
        hideAlertBanner={true}
        title={$t('pages.getStarted.signupForm.errorPage.title')}
        subtitle={$t('pages.getStarted.signupForm.errorPage.subtitle')}
        className="login-page signup-error-page"
      >
        <img
          className="error-image"
          src={config.gcpStorageUrl + '/img/signup-error.svg'}
          alt=""
        />
        <div className="signup-error-message">
          {$t('pages.getStarted.signupForm.errorPage.body')}
        </div>
        <Button
          className="back-button"
          type="primary"
          onClick={() =>
            dispatch(Actions.createAction(Actions.NAVIGATED_TO, routes.SIGN_UP))
          }
        >
          {$t('pages.getStarted.signupForm.errorPage.action')}
        </Button>
      </Page>
    </PageCard>
  )
}

export default SignupErrorPage
